/**
 * IAN Assist — Outlook Action Wrappers
 * Convenience wrappers around Office.js APIs for opening reply forms,
 * new message forms, etc.
 */

/* global Office */

/**
 * Open a reply form pre-populated with HTML body.
 * @param {string} htmlBody - HTML content to pre-fill
 */
export function openReplyForm(htmlBody) {
  try {
    Office.context.mailbox.item.displayReplyForm({
      htmlBody: htmlBody || '',
    });
  } catch (error) {
    console.error('Failed to open reply form:', error);
    throw new Error('Unable to open reply form. Please try again.');
  }
}

/**
 * Open a reply-all form pre-populated with HTML body.
 * @param {string} htmlBody
 */
export function openReplyAllForm(htmlBody) {
  try {
    Office.context.mailbox.item.displayReplyAllForm({
      htmlBody: htmlBody || '',
    });
  } catch (error) {
    console.error('Failed to open reply-all form:', error);
    throw new Error('Unable to open reply-all form. Please try again.');
  }
}

/**
 * Open a new message form.
 * @param {Object} params
 * @param {Array} [params.toRecipients]
 * @param {string} [params.subject]
 * @param {string} [params.htmlBody]
 */
export function openNewMessageForm({ toRecipients, subject, htmlBody } = {}) {
  try {
    Office.context.mailbox.displayNewMessageForm({
      toRecipients: toRecipients || [],
      subject: subject || '',
      htmlBody: htmlBody || '',
    });
  } catch (error) {
    console.error('Failed to open new message form:', error);
    throw new Error('Unable to open new message form. Please try again.');
  }
}

/**
 * Copy text to clipboard.
 * @param {string} text
 * @returns {Promise<boolean>}
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Clipboard write failed:', error);
    return false;
  }
}

/**
 * Set the subject line (compose mode only).
 * @param {string} subject
 */
export function setSubject(subject) {
  try {
    Office.context.mailbox.item.subject.setAsync(subject);
  } catch (error) {
    console.warn('Could not set subject:', error);
  }
}
